/**
 * @param {{ base: number, finalValue: number, }} [options={}]
 */
export function calcPercentual(options = {}) {
  const { base = 0, finalValue = 0 } = options;

  const isBaseFinite = Number.isFinite(base);
  const isFinalFinite = Number.isFinite(finalValue);
  const isValidBase = isBaseFinite && base > 0;

  if (!isValidBase || !isFinalFinite) return 0;

  return ((base - finalValue) / base) * 100;
}
